import type { ModuleId } from '@/constants/modules'

/** Soft midnight navy blended into every CTA end-stop (subtle, not dominant). */
const CTA_NAVY = '#172b4d'
const CTA_NAVY_DEEP = '#0f1f38'

/**
 * Brand primary CTA — maroon → soft navy (all modules).
 * Chips / accents stay module-colored; buttons use this brand wash.
 */
export interface ModuleCtaTokens {
  from: string
  mid: string
  to: string
  fromHover: string
  midHover: string
  toHover: string
  /** Flat fallback / rings */
  solid: string
  hoverSolid: string
  /** Space-separated RGB for colored drop shadow */
  shadowRgb: string
}

/** Maroon → navy — shared by every module for primary buttons */
const BRAND_CTA: ModuleCtaTokens = {
  from: '#7a1838',
  mid: '#a13535',
  to: CTA_NAVY,
  fromHover: '#64142e',
  midHover: '#8b2c2c',
  toHover: CTA_NAVY_DEEP,
  solid: '#a13535',
  hoverSolid: '#862c2c',
  shadowRgb: '161 53 53',
}

const MODULE_IDS: ModuleId[] = [
  'dashboard',
  'master-data',
  'sales',
  'inventory',
  'production',
  'dispatch',
  'purchases',
  'finance',
  'tasks',
  'reports',
  'user-management',
  'settings',
]

export const MODULE_CTA: Record<ModuleId, ModuleCtaTokens> = Object.fromEntries(
  MODULE_IDS.map((id) => [id, BRAND_CTA]),
) as Record<ModuleId, ModuleCtaTokens>

export function applyModuleCtaVars(
  target: HTMLElement,
  moduleId: ModuleId,
): void {
  const cta = MODULE_CTA[moduleId] ?? BRAND_CTA
  target.style.setProperty('--module-cta-from', cta.from)
  target.style.setProperty('--module-cta-mid', cta.mid)
  target.style.setProperty('--module-cta-to', cta.to)
  target.style.setProperty('--module-cta-from-hover', cta.fromHover)
  target.style.setProperty('--module-cta-mid-hover', cta.midHover)
  target.style.setProperty('--module-cta-to-hover', cta.toHover)
  target.style.setProperty('--module-cta-shadow-rgb', cta.shadowRgb)
  target.style.setProperty('--color-primary', cta.solid)
  target.style.setProperty('--color-primary-hover', cta.hoverSolid)
  target.style.setProperty('--color-ring', cta.solid)
}
